export default{
    "请填写简介": "Please fill in the profile",
    "请输入正确的邮箱": "Please enter vaild email",
    "请搜索或选择国家": "Please search or select country",
    "搜索已发布的作品": "Search your works",
    "请输入邮箱": "lease input your email",
    "请输入公司座机号": "请输入公司座机号",
    "请输入微信号": "请输入微信号",
    "请介绍一下您的团队或自己": "Introduce your team or yourself",
    "最多添加3个，上下拖拽可调整排序": "3 cases at most, drag up and down to adjust the sorting",
    "找项目": "Find Projects",
    "接项目": "Apply",
    "以下案例为平台用户已落地项目": "The following cases are projects that platform users have landed",
    "团队介绍": "Profile",
    "添加案例": "Add Cases",
    "上传新作品": "Upload works",
    "该作品已添加": "The work has been added",
    "请添加案例": "Please add cases",
    "项目对接": "Projects",
    "MANA项目对接": "MANA Project Docking",
    "创意内容供应和服务端与需求端双向对接，专业和产业链协同协作对接。":"Creative content supply and mutual connection of service-side and demand-side, collaboration of professional and industrial chain.",
    "MANA平台提供免费发布和自主匹配服务。": "Platform of MANA provides free publishing and autonomous matching services.",
    "发布项目": "发布项目",
    "参考案例": "Reference Cases",
    "应用场景": "Application Scenarios",
    "查看全部案例": "View Cases",
    "专业平台，精准资源": "Professional platform, precise resources",
    "MANA是全球艺术与科技创意内容分享与市场转化的专业平台；是新媒体艺术领域最具影响力的行业媒体之一。": "MANA is a platform for sharing and marketing the global art and technological innovation; It is one of the most influential media in the field of new media art.",
    "对接海量全球创作者资源": "Connecting with abundant global artists",
    "您将有机会对接到覆盖全球80%国家和地区的创作团队，合作领域涉及文旅、商业地产、医疗健康、休闲娱乐、科技教育等，助您找到最合适的创作者。": "You will have access to artists and studios covering 80% of the world's countries and regions, cooperating in fields including cultural tourism, commercial real estate, health and medicine, entertainment, technology and education with the most suitable team.",
    "免费推广机会": "Promotion for free",
    "在MANA对接成功的项目，有机会获得平台免费推广资源。": "For projects that MANA connects successfully, you will have the opportunity to receive free promotion resources on the platform.",
    "服务流程": "Service Process",
    "提交需求": "Submitting requirements",
    "审核发布": "Audit and release",
    "项目需求需要与科技艺术领域相关。审核结果将会在1个工作日内以邮件形式告知您。": "The project needs to be related to the field of technological art. The audit result will be notified to you by email within 1 working day",
    "对接资源": "Connecting with resources",
    "创作者的投递信息将以系统邮件形式发送到您的邮箱，需求发布后请注意查收邮件。": "The delivery result of the creator will be sent to in the form of mail. Please note to check the email after the requirement is released.",
    "其它服务": "Other Service",
    "商务客服邮箱": "If you want to recommend or gain more information of artists/studios through MANA, please contact Email:",
    "此服务为收费服务，按推荐/提供团队信息的数量收费，推荐/提供团队信息收费199元，或者可以购买年费服务。年度服务收费999元（全年推荐不超过20个团队）": "This service is a paid service, which is charged according to the amount of team information recommended/provided, which is 199 yuan, or the annual fee can be purchased. Annual service fee: RMB 999 (no more than 20 teams recommended throughout the year)",
    "MANA平台入驻创作者专属": "Creators on MANA platform have benefits as follows",
    "只有入驻MANA平台并发布作品的创作者才可以接项目": "",
    "入驻并发布作品": "Register and upload works",
    "类型": "Type",
    "地点": "Location",
    "项目预算": "Budget",
    "已结束": "Finished",
    "截止": "End",
    "需求方类型": "Demand-Side Type",
    "您尚未成为MANA平台创作者": "You are not yet a creator on MANA platform",
    "发布1部及以上原创作品，即可成为MANA平台创作者，才可以接项目哦～": "Upload 1 or more original works, you can become a creator on MANA platform before you can accept the project~",
    "去发布": "Upload",
    "请填写以下信息，我们将把您填写的信息通过系统自动发送邮件到需求方的邮箱。": "Please fill in the following information, and we will automatically send an email to the requester's mailbox through the system.",
    "查看邮件示例": "View mail example",
    "以下默认为您在个人中心上填写的信息。修改后仅用于邮件发送，将不会同时修改您的个人资料。": "The following defaults to the information you fill in the personal center. It will only be used for mailing, and your personal information will not be modified at the same time.",
    "暂无": "No information",
    "找供应商": "Find Suppliers",
    "删除": "Delete",
    "找全案服务": "Find Package Service",
    "找专业服务": "Find Professional Service",
    "咨询顾问、策划策展、创意创作、软硬件及工程技术、项目运营": "Consultant, Curator, Creator, Skilled technicians, Project operator",
    "咨询-方案-资源-落地-运营": "Consulting - Planning - Resourcing - Realizing - Operating",
    "最多添加3个": "3 cases at most",
    "全案服务": "Package Service ",
    "咨询顾问": "Consultant ",
    "策展策划": "Curator ",
    "创意创作": "Creator ",
    "软硬件及工程技术": "Skilled technicians ",
    "项目运营": "Project operator ",
    "整体解决方案": "Package service ",
    "资讯、策划": "News & planning ",
    "方案设计": "Plans & designs ",
    "项目执行": "Project execution ",
    "3万以下": "Below RMB30K",
    "3-10万": "RMB30K to 100K",
    "10-20万": "RMB100K to 200K",
    "20-50万": "RMB200K to 500K",
    "50-100万": "RMB500K to 1M",
    "100万以上": "Above 1M",
}



// WEBPACK FOOTER //
// ./src/languages/en/project.js